/* eslint-disable @typescript-eslint/no-explicit-any */
// jQuery is needed for the WYSIWYG editor Trumbowyg
import jquery from "jquery";
(window as any).$ = jquery;
(window as any).jQuery = jquery;
